import { Dialog, DialogContent, DialogTitle } from "@mui/material";

export default function SubdimensionDialog({
  onClose,
  subdimension,
  subdimensions,
}) {
  if (subdimensions && subdimension) {
    const selected_subdimension = subdimensions.find(
      (sd) => sd.name === subdimension
    );

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog onClose={handleClose} open={Boolean(subdimension)}>
        <DialogTitle>Subdimension {selected_subdimension.title}</DialogTitle>
        <DialogContent>
          <p>{selected_subdimension.description}</p>
        </DialogContent>
      </Dialog>
    );
  }

  return;
}
